import { z } from 'zod';

import { ActorSchema } from '../task/task';
import { CardIdSchema } from '../card/card_id';
import { TaskIdSchema } from '../task/task_id';

export const AuditEntryIdSchema = z.guid().brand<'AuditEntryId'>();

export type AuditEntryId = z.infer<typeof AuditEntryIdSchema>;

/**
 * Append-only audit row. Spec v4 §audit_entries — every state-changing
 * use case writes one of these in the same Mongo transaction as the
 * mutation it records. `correlationId` groups writes from a single API
 * call (e.g. `task.claim` writes one `audit_entries` row and one
 * `handoff_events` row under the same `correlationId`).
 *
 * `changeset` is the free-form mutation payload — its shape is keyed by
 * `action`, but kept un-typed at this layer because consumers (audit
 * viewer in Phase 8) only render it generically.
 */
export const AuditEntrySchema = z.object({
  id: AuditEntryIdSchema,
  at: z.coerce.date(),
  actor: ActorSchema,
  cardId: CardIdSchema,
  taskId: TaskIdSchema.nullable(),
  action: z.string().min(1).max(100),
  correlationId: z.string().min(1).max(200),
  changeset: z.record(z.string(), z.unknown()),
});

export type AuditEntry = z.infer<typeof AuditEntrySchema>;
